import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HTTPApi from "i18next-http-backend";

// Get saved language from localStorage, default to 'en'
const savedLanguage = localStorage.getItem("appLanguage") || "en";

i18n
  .use(initReactI18next)
  .use(HTTPApi)
  .init({
    lng: savedLanguage,
    fallbackLng: "en",
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
